var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._b({ref:"cascader",staticClass:"cascader-wrap",attrs:{"value":_vm.value,"props":_vm.props},on:{"change":_vm.handleChange}},'el-cascader',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }